import _throttle from 'lodash/throttle';
/**
 * 事件修饰符
 */
// 定义 EventHandler 类型，用于表示事件处理函数
type EventHandler = (event?: Event, ...args: any[]) => any;

// stopPropagation 装饰器
export function stopPropagation(
    target: Object,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<EventHandler>,
) {
    const originalMethod = descriptor.value!;
    descriptor.value = function (event?: Event, ...args: any[]) {
        event?.stopPropagation?.();
        return originalMethod.call(this, event, ...args);
    };

    return descriptor;
}

// preventDefault 装饰器
export function preventDefault(
    target: Object,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<EventHandler>,
) {
    const originalMethod = descriptor.value!;

    descriptor.value = function (event?: Event, ...args: any[]) {
        event?.preventDefault?.();
        return originalMethod.call(this, event, ...args);
    };

    return descriptor;
}

export function createThrottleDecorator(time: number) {
    return function (
        target: Object,
        propertyKey: string,
        descriptor: TypedPropertyDescriptor<EventHandler>,
    ) {
        const originalMethod = descriptor.value!;

        descriptor.value = _throttle(originalMethod, time);

        return descriptor;
    };
}
